import React from 'react';
import { Box, Typography } from 'vindi-ds-components';

const Header = () => (
  <Box css={{ marginBottom: '1em' }}>
    <Typography variant='subtitle2'>Simulador de preço</Typography>
  </Box>
);

export default Header;
